/*
String formating mixins.
------------------------------------------------------------------------ */
import pluralize from 'pluralize'

export default {

  methods: {

    webSafeFileName (str) {
      return str.replace(/[\\~#%&*{}/:<>?|"-]/g, '\\$&')
    },


    removeSpecialChars (str) {
      return str.replace(/[^a-zA-Z ]/g, ' ')
    },


    // XOL-148: make a display/org name safe to drop into a URL *path* segment.
    // Strips only the chars that break at the HTTP layer — '?' (starts the query),
    // '#' (fragment), '%' (malformed percent-encoding) and '\' (browsers fold it to '/').
    // A literal '/' is intentionally left intact (the API route captures it) and spaces
    // are left for the browser to percent-encode.
    urlSafeName (str) {
      return str ? String(str).replace(/[\\?#%]/g, ' ').trim() : str
    },



    titleCase (str, rem = null) {
      if (rem) {
        str = str.replace(rem, ' ')
      }

      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    },


    allCaps (value) {
      return value.toUpperCase()
    },


    camelize (str) {
      return str.replace(/([A-Z])/g, (match) => ` ${match}`).replace(/^./, (match) => match.toUpperCase())
    },


    ellipsis (str, num = 24) {

      if (!str) {
        return null
      }

      if (str && str.length > num) {
        return str.substring(0, num) + '...'
      }

      return str
    },


    // This a more exact version than the basic one in main.js
    pluralise (str, qty = 0) {
      return pluralize(str, qty)
    }

  }

}
